import React from 'react';
import styled from 'styled-components';

import ManualAccountLogo from 'components/accounts/ManualAccountLogo';
import ImageWithFallback from 'components/lib/ui/ImageWithFallback';

import { variables } from 'common/lib/theme/dynamic';

const DEFAULT_SIZE_PX = 48;

const Root = styled.div<{ $logoUrl?: string | null; $size: number }>`
  border-radius: 100%;
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  flex-shrink: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-image: url('${({ $logoUrl }) => $logoUrl}');
  box-shadow: inset 0 0 0 1px ${variables.color.avatar.border};
`;

export type AccountLogoProps = {
  logoUrl?: string | null;
  icon?: string | null;
};

type Props = {
  size?: number;
  className?: string;
} & AccountLogoProps;

const AccountLogo = ({ logoUrl, className, icon, size = DEFAULT_SIZE_PX }: Props) => (
  <ImageWithFallback
    src={logoUrl}
    fallback={<ManualAccountLogo size={size} icon={icon || 'dollar-sign'} className={className} />}
  >
    <Root $logoUrl={logoUrl} className={className} $size={size} />
  </ImageWithFallback>
);

export default AccountLogo;
